import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/document-edit-button.scss';

Component('tr-document-edit-button', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    name: String,
  },

  connected() {
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.windowObjectReference = window.open(this.url, this.name);
    this.windowObjectReference.focus();
  },

  closeEditWindow({ redirectUrl }) {
    if (this.windowObjectReference) this.windowObjectReference.close();
    window.focus();
    window.tower.stack.load(redirectUrl, {
      nocache: true,
      replace: true,
      root: true,
      fluid: true,
    });
  },

  disconnected() {
    this.stopListening();
    this.windowObjectReference = null;
  },
});
